export const VIEW_PARAM_KEY = "view";
export const TEMPLATE_PARAM_KEY = "preset-template";

export const ASSIGN_REFERRED_KEY = "assign";
